<template>
  <div v-if="enabled" class="p-4 lg:p-6">
    <h5 class="font-medium text-sm leading-none">{{ name }}</h5>
    <p class="text-gray-500 text-xs">{{ desc }}</p>
    <div class="divide-y border rounded-md mt-2">
      <div
        v-for="option in enabledOptions"
        :key="option.id"
        class="p-3 flex items-center"
        :class="{
          'hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer select-none':
            !readonly,
        }"
        @click="!readonly && input(option.id)"
      >
        <Check v-if="readonly" :checked="option.id == value" />
        <Check v-else :checked="activeAddonOption(option.id)" />

        <p class="text-sm ms-2 leading-none">{{ option.label }}</p>
        <Amount class="block text-sm ms-auto font-bold" :value="option.rate" />
      </div>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/store/cart.js";
import { mapState, mapActions } from "pinia";

export default {
  props: {
    options: { type: Array, default: null },
    name: { type: String, default: null },
    desc: { type: String, default: null },
    status: { type: String, default: null },
    readonly: { type: Boolean, default: false },
    value: { type: Number, default: null },
  },
  data() {
    return {
      activeId: null,
    };
  },

  computed: {
    ...mapState(useCartStore, ["checkoutAddonsId"]),

    enabled() {
      return (
        this.status === "active" &&
        this.options.filter((option) => option.status === "active").length > 0
      );
    },
    enabledOptions() {
      return this.options.filter((item) => item.status === "active");
    },
  },

  methods: {
    ...mapActions(useCartStore, ["upsertCart"]),
    activeAddonOption(value) {
      if (this.checkoutAddonsId.includes(value)) {
        this.activeId = value;
        return true;
      } else return false;
    },
    input(value) {
      if (this.checkoutAddonsId.includes(value)) {
        // Toggle selected
        const ids = this.checkoutAddonsId.filter(
          (addonId) => addonId !== value
        );

        this.upsertCart({
          checkoutAddonOptionId: ids,
        });
      } else {
        /**
         * at one time, only one options is allowed to select ( its a radio field )
         */

        const filteredIds = this.checkoutAddonsId.filter((addonId) => {
          return addonId !== this.activeId;
        });

        this.upsertCart({
          checkoutAddonOptionId: [...filteredIds, value],
        });
      }
    },
  },
};
</script>
